import { ToastContainer } from "react-toastify";
import { FindMonitors } from "../../components/Adm/FindMonitors";
import { ErrorBoundary } from "../../components/shared/ErrorBoundary";

export default function MonitorPage() {
  return (
    <>
      <ToastContainer />
      {/* Escopo local, de propósito: um erro de render aqui (mapa, camada de pontos)
          fica contido nesta tela em vez de apagar o admin inteiro. A fronteira global
          continua sendo decisão de ADR em aberto. */}
      <ErrorBoundary
        title="Não foi possível exibir o histórico de localização"
        description="Ocorreu um erro inesperado ao montar o mapa. Tente novamente ou recarregue a página."
      >
        <FindMonitors />
      </ErrorBoundary>
    </>
  );
}
